import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
//import { UserService } from './user.service';
import { tap } from 'rxjs/operators';
import {  Observable } from 'rxjs';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { isPlatformBrowser } from '@angular/common';
import { secureStorage } from './secure-storage.service';
import { CookieService } from './cookie.service';
import { AppConfig, applicationConfiguration } from '../interceptor/app.config';
import { BehaviourSubjectService } from './behaviour-subject.service';
import { TokenService } from './token.service';
import { lastValueFrom } from 'rxjs'; // Add this 
import { formatDate } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class RootService {
  showServicecall: boolean = false;
  expiredDate: any;
  protected server = this.appConfig.apiUrl + 'api/eol/v1/pv/';
  protected serve = this.appConfig.apiUrl;
  protected pvServer = this.appConfig.apiUrl + 'api/eol/v1/pv/account/';
  readonly options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'request-id': 'b997a77ae2b3f30c1bed151c3e42434f',
    }),
  };
  encryptedData: any;
  // $encrypt: JSEncrypt | undefined;
  constructor(
    //private userService: UserService,
    private router: Router,
    private behaviorService: BehaviourSubjectService,
    private http: HttpClient,
    @Inject(applicationConfiguration) private appConfig: AppConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
    private localstorage: secureStorage,
    private ssrcookieService: CookieService,
    private tokenService: TokenService
  ) {

  }

  getBrowserID() {
    return this.platformId;
  }


  encryptAES(value: string) {
    let data = CryptoJS.AES.encrypt("test_data", "mypassword");
  }

  get jsonFormatter() {
    return {
      stringify: (cipherParams: any) => {
        const jsonObj = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64), iv: null, s: null };
        if (cipherParams.iv) {
          jsonObj.iv = cipherParams.iv.toString();
        }
        if (cipherParams.salt) {
          jsonObj.s = cipherParams.salt.toString();
        }
        return JSON.stringify(jsonObj);
      },
      parse: (jsonStr: any) => {
        const jsonObj = JSON.parse(jsonStr);
        // extract ciphertext from json object, and create cipher params object
        const cipherParams = CryptoJS.lib.CipherParams.create({
          ciphertext: CryptoJS.enc.Base64.parse(jsonObj.ct)
        });
        if (jsonObj.iv) {
          cipherParams.iv = CryptoJS.enc.Hex.parse(jsonObj.iv);
        }
        if (jsonObj.s) {
          cipherParams.salt = CryptoJS.enc.Hex.parse(jsonObj.s);
        }
        return cipherParams;
      }
    };
  }

  getToken(): Promise<any> {
    let promise: Promise<any> = Promise.resolve();
    const userCode = this.tokenService.getUserCode();
    const accessToken = this.tokenService.getAccessToken();
    
    
    try {
      if (isPlatformBrowser(this.platformId)) {
        // Check if user has valid tokens and token is not expiring soon
        if (accessToken && !this.tokenService.isTokenExpired() && !this.tokenService.isTokenExpiringSoon(30)) {
          return Promise.resolve();
        }
        
        // Only generate token if we don't have one, if it's expired, or if it's expiring soon
        if (!accessToken || this.tokenService.isTokenExpired() || this.tokenService.isTokenExpiringSoon(30)) {
          this.showServicecall = true;

          // Generate encrypted user code for token generation
          const encryptedUserCode = this.generateEncryptedUserCode();

          // Create headers with encrypted user code
          const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'request-id': 'b997a77ae2b3f30c1bed151c3e42434f',
            'user-code': encryptedUserCode
          });

          const requestOptions = { headers };

          promise = lastValueFrom(
            this.http.post(`${this.pvServer}generate_token/`, null, requestOptions)
          )
          .then((response: any) => {
            if (response.success) {
              this.tokenService.storeAuthData({
                access_token: response.data['access_token'],
                refresh_token: response.data['refresh_token'],
                user_code: userCode || '', // Keep existing user code if available
                expires_in: response.data['expires_in']
              });
              
              this.localstorage.setItem('eolrefreshTokenInProgress', 'false');
              this.behaviorService.freeSearchTokenUpdated.next(response.data);
            } else {
              console.error('generate_token API failed: ', response);
            }
            this.showServicecall = false;
          })
          .catch((error) => {
            console.error('generate_token API error:', error);
            this.showServicecall = false;
          });
        }
      }
    } catch (error) {
      console.error('getToken() Exception:', error);
      this.showServicecall = false;
    }

    return promise;
  }

  // Generate token for non-logged-in users (free search)
  generateTokenForFreeSearch(): Promise<any> {
    let promise: Promise<any> = Promise.resolve();
    
    try {
      if (isPlatformBrowser(this.platformId)) {
        // Check if user is already authenticated - if so, use getToken instead
        const userCode = this.tokenService.getUserCode();
        if (userCode) {
          return this.getToken();
        }
        
        // Check if we already have a valid free search token and it's not expiring soon
        const accessToken = this.tokenService.getAccessToken();
        if (accessToken && !this.tokenService.isTokenExpired() && !this.tokenService.isTokenExpiringSoon(30)) {
          return Promise.resolve();
        }
        
        // Only generate token if we don't have one, if it's expired, or if it's expiring soon
        if (!accessToken || this.tokenService.isTokenExpired() || this.tokenService.isTokenExpiringSoon(30)) {
          this.showServicecall = true;

          // Generate encrypted user code for non-logged-in users
          const encryptedUserCode = this.generateEncryptedUserCode();

          // Create headers with encrypted user code
          const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'request-id': 'b997a77ae2b3f30c1bed151c3e42434f',
            'user-code': encryptedUserCode
          });

          const requestOptions = { headers };

          promise = lastValueFrom(
            this.http.post(`${this.pvServer}generate_token/`, null, requestOptions)
          )
          .then((response: any) => {
            if (response.success) {
              this.tokenService.storeAuthData({
                access_token: response.data['access_token'],
                refresh_token: response.data['refresh_token'],
                user_code: '', // No user code for free search
                expires_in: response.data['expires_in']
              });
              
              this.localstorage.setItem('eolrefreshTokenInProgress', 'false');
              this.behaviorService.freeSearchTokenUpdated.next(response.data);
            } else {
              console.error('generate_token API failed: ', response);
            }
            this.showServicecall = false;
          })
          .catch((error) => {
            console.error('generate_token API error:', error);
            this.showServicecall = false;
          });
        }
      }
    } catch (error) {
      console.error('generateTokenForFreeSearch() Exception:', error);
      this.showServicecall = false;
    }

    return promise;
  }

  // Generate encrypted user code for non-logged-in users
  private generateEncryptedUserCode(): string {
    const activationDate = new Date();
    let newDate = formatDate(activationDate, 'yyyy-MM-dd' + 'T' + 'HH:mm:ss', 'en-GB')
    newDate = newDate + "Z"
    var skey = "dwjdwi-jdwijdwiwinwdidwindiwmwcinqppkq="
    var salt = "dwindiwmw==";
    var iterations = 128;
    var bytes = CryptoJS.PBKDF2(skey, salt, { keySize: 48, iterations: iterations });
    var iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    var key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));
    var encrypteDate = CryptoJS.AES.encrypt(newDate, key, { iv: iv }).toString();
    
    return encrypteDate;
  }

  getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
  }

  refreshToken(): Promise<any> {
    let promise: any
    try {
      if (isPlatformBrowser(this.platformId)) {
        let refreshToken = this.tokenService.getRefreshToken();
        let data = {}
        if (refreshToken) {
          let userDetail = this.localstorage.getItem('eol_ref_token') ? this.localstorage.getItem('eol_ref_token') : ''
          if(userDetail){
            this.behaviorService?.isLoggedIn.next(true)
          }
          data = {
            refresh_token: refreshToken
          }
          if (!this.showServicecall) {
            this.showServicecall = true;
            promise = this.http.post(`${this.pvServer}refresh_token/`, data, this.options).toPromise()
              .then((response: any) => {
                this.showServicecall = false;
                if (response['success'] === true) {
                  this.tokenService.storeAuthData({
                    access_token: response.data['access_token'],
                    refresh_token: response.data['refresh_token'],
                    user_code: this.tokenService.getUserCode() || '',
                    expires_in: response.data['expires_in']
                  });
                  
                  this.localstorage.setItem('eolrefreshTokenInProgress', 'false');
                } else {
                  this.clearsession();
                }
                return
              }).catch(err => {
                if (err.status == 400 || err.status == 412) {
                  this.clearsession();
                }
              });
            return promise;
          }
        }
      }
    }
    catch (error) {
      throw (error)
    }
    return promise;
  }


  refreshToken2(): Observable<any> {
    let data = {}
    if (isPlatformBrowser(this.platformId)) {
      let refreshToken = this.tokenService.getRefreshToken();
      const userCode = this.tokenService.getUserCode();
      
      if (refreshToken) {
        data = {
          refresh_token: refreshToken
        }
      }
      
      if (!this.showServicecall && refreshToken) {
        this.showServicecall = true;
        return this.http.post<any>(`${this.pvServer}refresh_token/`, data, this.options
        ).pipe(tap((response) => {
          if (response.success) {
            this.showServicecall = false;
            this.localstorage.setItem('eolrefreshTokenInProgress', 'false');
            this.storeJwtToken(response);
          } else {
            this.clearsession();
          }
        }, err => { 
          this.clearsession(); 
        }));
      }
    }
    
    // Return empty observable if conditions not met
    return new Observable(subscriber => {
      subscriber.error(new Error('Cannot refresh token - missing refresh token or service call in progress'));
    });
  }


  private storeJwtToken(response: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (response['success'] === true) {
        this.tokenService.storeAuthData({
          access_token: response.data['access_token'],
          refresh_token: response.data['refresh_token'],
          user_code: this.tokenService.getUserCode() || '',
          expires_in: response.data['expires_in']
        });
        
        this.localstorage.setItem('eolrefreshTokenInProgress', 'false');
      }
    }
  }

  getCartType() {
    try {
      if (isPlatformBrowser(this.platformId)) {
        if (!this.localstorage.getItem('getCartType')) {
          localStorage.removeItem('getCartType');
          this.http.post(`${this.serve}api/v1/ecom/cart/cart_type/list/`, this.options).toPromise()
            .then((response: any) => {
              if (response['success'] === true) {
                let cartArray = [];
                cartArray = response.data;
                cartArray.forEach((element: any) => {
                  element.cart_count = 0;
                })
                this.localstorage.setItem('getCartType', JSON.stringify(cartArray));
              }
            })
        }
      }
    }
    catch (error) {
    }

  }

  clearsession() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
      this.localstorage.clear()
      this.tokenService.clearAuth();
      this.ssrcookieService.removeItem('eol_user');
      this.behaviorService.isLoggedIn.next(false);
      this.router.navigate(['']);
      this.showServicecall = false;
      // Remove the getToken call as it's not needed after clearing session
      // Token will be generated when needed by the interceptor
    }
  }


  isLoggedIn() {
    if (isPlatformBrowser(this.platformId)) {
      return this.tokenService.isAuthenticated() && localStorage.getItem('selectedUserData')
        ? true
        : false
    }else{
      return false
    }
  }
}

